import {
    ICalendarEvent, IEvent,
} from '@/interfaces';
import { EventsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setEvents(state: EventsState, payload: ICalendarEvent[]) {
        state.events = payload;
    },
    setEvent(state: EventsState, payload: IEvent) {
        state.event = payload;
    },
};

const {commit} = getStoreAccessors<EventsState | any, State>('');

export const commitSetEvents = commit(mutations.setEvents);
export const commitSetEvent = commit(mutations.setEvent);
